import { socket } from "../index";

const emitCreateRoom = (
  name: string,
  description: string,
  maxParticipants: number,
  isPremium: boolean,
  isSecret: boolean,
  password: string | null = null,
) => {
  socket?.emit('CREATE_ROOM', { 
    name,
    description,
    maxParticipants,
    isPremium,
    isSecret,
    password,
  });
}

export default emitCreateRoom;